class Authentication {
}
export {
  Authentication
};
//# sourceMappingURL=authentication.js.map
